import { importLibrary } from '@googlemaps/js-api-loader';
import type { AddressDuration, Branch } from './models/JobSharedInterfaces';
import type { AddressDetails } from './models/JobInterfaces';
import type { GoogleAddressItem } from './models/JobScheduleInterfaces';

//office: 1=Bayswater North, 2=Pakenham, 3=Traralgon, 4=Geelong
interface TotalDistance {
    distance: number,
    duration: number
};

export const calculateAddressDuration = async (branches: Branch[], addressDetails: AddressDetails) => {
    var shortestDuration = 0;
    var shortestDistance = 0;
    var branchId = 1;   //Default to Bayswater

    for (var b = 0; b < branches.length; b++) {
        var branch = branches[b];

        var branchAddrLatLng: GoogleAddressItem = {
            lat: branch.latitude,
            lng: branch.longitude,
            fullAddress: branch.fullAddress
        };

        var siteAddrLatLng: GoogleAddressItem = {
            lat: addressDetails.latitude,
            lng: addressDetails.longitude,
            fullAddress: addressDetails.fullAddress
        };

        var result = await calculateDistance(branchAddrLatLng, siteAddrLatLng);
        if (result && (shortestDuration === 0 || shortestDuration > result.duration)) {
            shortestDuration = result.duration;
            shortestDistance = result.distance;
            branchId = branch.id;
        };

        var mins = shortestDuration / 60;
        if (mins <= 45) {
            //within the city limits so don't need to check the rest of the addresses
            break;
        }
    }

    var shortestDist = shortestDistance / 1000;
    var shortestDur = shortestDuration / 60;

    var addAddr: AddressDuration = {
        distance: shortestDist,
        duration: shortestDur,
        branchId: branchId
    };
    return addAddr;
}


export async function calculateDistance(officeLocation: GoogleAddressItem, siteAddress: GoogleAddressItem) {
    const { Route, TravelMode } = await importLibrary("routes");

    //set lat lng for start and end addresses as more efficient for google to use that rather than the actual address
    const origin = new google.maps.LatLng(officeLocation.lat, officeLocation.lng);
    const dest = new google.maps.LatLng(siteAddress.lat, siteAddress.lng);

    var request: google.maps.routes.ComputeRoutesRequest = {
        origin: officeLocation.lat === 0 && officeLocation.lng === 0 ? officeLocation.fullAddress : origin,
        destination: siteAddress.lat === 0 && siteAddress.lng === 0 ? siteAddress.fullAddress : dest,
        travelMode: TravelMode.DRIVING,
        fields: ['distanceMeters', 'staticDurationMillis']
    };

    try {
        const response = await Route.computeRoutes(request);
        if (response && response.routes) {
            const distance = response.routes[0].distanceMeters ?? 0;
            const durationMilliseconds = response.routes[0].staticDurationMillis ?? 0;

            const durationSeconds = Math.round(durationMilliseconds / 1000);

            var totalDistance: TotalDistance = {
                distance: distance,
                duration: durationSeconds
            };
            return totalDistance
        } else {
            var noRoute: TotalDistance = {
                distance: 0,
                duration: 0
            };
            return noRoute;
        }
    } catch (error) {
        var noRoute: TotalDistance = {
            distance: 0,
            duration: 0
        };
        return noRoute;
    }
}


export async function calculateDistanceRoute(officeLocation: GoogleAddressItem, siteAddresses: GoogleAddressItem[]) {
    const { Route, TravelMode } = await importLibrary("routes");

    //set lat lng for start and end addresses as more efficient for google to use that rather than the actual address
    const origin = new google.maps.LatLng(officeLocation.lat, officeLocation.lng);

    const waypts: google.maps.routes.Waypoint[] = [];
    for (var i = 0; i < siteAddresses.length; i++) {
        const wayPtLat = siteAddresses[i].lat;
        const wayPtLng = siteAddresses[i].lng;
        const wayPtLatLng = new google.maps.LatLng(siteAddresses[i].lat, siteAddresses[i].lng);
        const wayPtAddr = siteAddresses[i].fullAddress;

        waypts.push({
            location: wayPtLat === 0 && wayPtLng === 0 ? wayPtAddr : wayPtLatLng,
            vehicleStopover: true
        });
    }

    var request: google.maps.routes.ComputeRoutesRequest = {
        origin: officeLocation.lat === 0 && officeLocation.lng === 0 ? officeLocation.fullAddress : origin,
        destination: officeLocation.lat === 0 && officeLocation.lng === 0 ? officeLocation.fullAddress : origin,
        intermediates: waypts,
        optimizeWaypointOrder: false,
        travelMode: TravelMode.DRIVING,
        fields: ['distanceMeters', 'staticDurationMillis']
    };

    try {
        const response = await Route.computeRoutes(request);
        if (response && response.routes) {
            const distance = response.routes[0].distanceMeters ?? 0;
            const durationMilliseconds = response.routes[0].staticDurationMillis ?? 0;

            const durationSeconds = Math.round(durationMilliseconds / 1000);

            var totalDistance: TotalDistance = {
                distance: distance,
                duration: durationSeconds
            };
            return totalDistance
        } else {
            var noRoute: TotalDistance = {
                distance: 0,
                duration: 0
            };
            return noRoute;
        }
    } catch (error) {
        var noRoute: TotalDistance = {
            distance: 0,
            duration: 0
        };
        return noRoute;
    }

}
